import { ICarrierSelect } from "../../interfaces/form";
import { ALL_CARRIERS_OPTION } from "../../utils/constants";
import { GenericAutocomplete } from "../GenericAutocomplete";

const CarrierSelect = ({
  carriers,
  handleChangeValue,
  initialValues,
}: ICarrierSelect) => {
  const parsedCarriers = carriers.map(({ _id: id, name }) => ({
    id,
    name,
  }));

  return (
    <GenericAutocomplete
      initialValues={initialValues}
      options={parsedCarriers}
      allOption={ALL_CARRIERS_OPTION}
      handleChangeValue={handleChangeValue}
      label="Operadores logísticos"
      fieldKey="carriers"
      noOptionsText="No se encontró el operador."
    />
  );
};

export default CarrierSelect;
